<template>
	<div class="user-detail-page" :class="{ 'user-detail-page--embedded': embedded }">
		<a-page-header
			v-if="!embedded"
			@back="goBack"
			style="background-color: #fff; padding:24px 24px 0 24px;"
			:title="headerTitle"
		/>

		<a-spin :spinning="loading">
			<div class="detail-content">
				<template v-if="!loading && userInfo.id">
					<div class="detail-section profile-header">
						<div class="profile-top">
							<div class="avatar-wrap">
								<img v-if="userInfo.avatarUrl" :src="userInfo.avatarUrl" class="avatar" alt="头像" />
								<div v-else class="avatar avatar-placeholder">暂无头像</div>
								<span v-if="statusText" class="avatar-status">{{ statusText }}</span>
							</div>
							<div class="profile-meta">
								<div class="profile-name-line">
									<span class="nickname">{{ userInfo.nickname || '-' }}</span>
									<span v-if="userInfo.isActor === 'Y'" class="actor-tag">【聊客】</span>
									<span
										:class="['voice-link', { 'voice-link--disabled': !voiceUrl, 'voice-link--playing': voicePlaying }]"
										@click="toggleVoice"
									>声音秀</span>
									<audio
										ref="voiceAudio"
										:src="voiceUrl"
										@play="voicePlaying = true"
										@pause="voicePlaying = false"
										@ended="voicePlaying = false"
									/>
								</div>
								<div class="profile-basic">
									<span>{{ sexText }}</span>
									<span>{{ userInfo.age != null ? userInfo.age + '岁' : '-' }}</span>
									<span>{{ maritalText }}</span>
									<span>{{ locationText }}</span>
								</div>
								<div class="profile-signature" :class="{ placeholder: !mottoText }">{{ mottoText || '个性签名' }}</div>
							</div>
							<div class="profile-divider" />
							<div class="profile-stats">
								<div class="stat-item">
									<div class="stat-label">金币</div>
									<div class="stat-value">{{ userInfo.gold != null ? userInfo.gold : '-' }}</div>
								</div>
								<div class="stat-item">
									<div class="stat-label">积分</div>
									<div class="stat-value">{{ userInfo.score != null ? userInfo.score : '-' }}</div>
								</div>
								<div class="stat-item">
									<div class="stat-label">充值</div>
									<div class="stat-value">{{ rechargeText }}</div>
								</div>
								<div class="stat-item">
									<div class="stat-label">提现</div>
									<div class="stat-value">{{ withdrawText }}</div>
								</div>
								<div class="stat-item">
									<div class="stat-label">通话</div>
									<div class="stat-value">{{ callText }}</div>
								</div>
							</div>
						</div>
						<div class="photo-gallery" v-if="albumList.length">
							<div class="photo-item" v-for="item in albumList" :key="item.id || item.photoUrl">
								<x-image :src="item.photoUrl" :width="88" :height="88" />
							</div>
						</div>
					</div>

					<div class="detail-section-main">
						<a-card class="detail-card">
							<div class="detail-grid">
								<div class="detail-item"><span class="label">账号:</span><span class="val">{{ userInfo.account || '-' }}</span></div>
								<div class="detail-item"><span class="label">魅力:</span><span class="val">{{ charmText }}</span></div>
								<div class="detail-item"><span class="label">手机号:</span><span class="val">{{ userInfo.phone || userInfo.mobile || '-' }}</span></div>
								<div class="detail-item"><span class="label">邀请人:</span><span class="val">{{ userInfo.parentUserNickname || '-' }}</span></div>

								<div class="detail-item"><span class="label">身高:</span><span class="val">{{ heightText }}</span></div>
								<div class="detail-item"><span class="label">学历:</span><span class="val">{{ dictLabel(dict.qualification, userInfo.qualification) }}</span></div>
								<div class="detail-item"><span class="label">工作:</span><span class="val">{{ userInfo.workName || '-' }}</span></div>
								<div class="detail-item"><span class="label">年收入:</span><span class="val">{{ dictLabel(dict.income, userInfo.income) }}</span></div>

								<div class="detail-item"><span class="label">注册时间:</span><span class="val">{{ registerTimeText }}</span></div>
								<div class="detail-item"><span class="label">活跃时间:</span><span class="val">{{ activeTimeText }}</span></div>
								<div class="detail-item"><span class="label">手机:</span><span class="val">{{ formatPhone(userInfo) }}</span></div>
								<div class="detail-item"><span class="label">渠道:</span><span class="val">{{ userInfo.spreadChannelName || '-' }}</span></div>
							</div>
						</a-card>

						<!-- Tab 切换 + 列表（占满整行） -->
						<a-card class="detail-card record-tabs-card record-tabs-card-full">
                            <a-tabs :activeKey="recordTab" @change="onRecordTabChange">
                                <a-tab-pane key="message" tab="聊天记录" />
                                <a-tab-pane key="call" tab="通话记录" />
                                <a-tab-pane key="recharge" tab="充值记录" />
                                <a-tab-pane key="withdraw" tab="提现记录" />
                                <a-tab-pane key="gold" tab="金币流水" />
                                <a-tab-pane key="score" tab="积分流水" />
                                <a-tab-pane key="invite" tab="邀请记录" />
                            </a-tabs>
                            <a-table
                                :columns="recordTableColumns"
                                :dataSource="recordList"
                                :rowKey="(r, i) => r.id || i"
                                :loading="recordLoading"
                                :pagination="false"
                                :rowClassName="recordRowClassName"
                                :customRow="recordCustomRow"
                                size="small"
                                bordered
                            >
                                <template slot="callPeer" slot-scope="text, record">
                                    <div class="record-user-cell">
                                        <img v-if="record.peerUserAvatarUrl" :src="record.peerUserAvatarUrl" class="record-user-avatar" alt="" />
                                        <span v-else class="record-user-avatar-placeholder">头像</span>
                                        <span class="record-user-info">
                                            <span>
                                                {{ record.peerUserNickname || '-' }}
                                                <template v-if="record.peerUserIsActor === 'Y'">[聊客]</template>
                                            </span>
                                            <span class="record-user-meta">
                                                <template v-if="record.peerUserAge">{{ record.peerUserAge }}岁</template>
                                                <template v-if="record.peerUserProvince || record.peerUserCity"> {{ record.peerUserProvince }}{{ record.peerUserCity }}</template>
                                                <template v-if="!record.peerUserAge && !record.peerUserProvince && !record.peerUserCity">-</template>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                                <template slot="callType" slot-scope="text, record">
                                    {{ record.isCaller === 'Y' ? '主叫' : '被叫' }} - {{ record.callType === 'VILTE' ? '视频' : '语音' }}
                                </template>
                                <template slot="callStatus" slot-scope="text, record">
                                    <div class="record-complex">
                                        <span v-if="record.status === 'INVITE'" class="wait">呼叫中</span>
                                        <span v-else-if="record.status === 'CALLING'" class="wait">正在通话</span>
                                        <template v-else>
                                            <span v-if="record.isConnect === 'Y'">通话结束</span>
                                            <span v-else class="error">未接通</span>
                                            <p class="assist" v-if="record.callLenText">{{ record.callLenText }}</p>
                                        </template>
                                        <p class="assist" v-if="record.hangup == 1">被叫拒绝</p>
                                        <p class="assist" v-else-if="record.hangup == 2">被叫未接听</p>
                                        <p class="assist" v-else-if="record.hangup == 3">主叫取消</p>
                                        <p class="assist" v-else-if="record.hangup == 4">支出方金币不足挂断</p>
                                        <p class="assist" v-else-if="record.hangup == 5">违规中断</p>
                                    </div>
                                </template>
                                <template slot="callBill" slot-scope="text, record">
                                    <span v-if="record.billMinutes > 0">{{ record.billMinutes }}分钟</span>
                                    <span v-else>-</span>
                                </template>
                                <template slot="callExpend" slot-scope="text, record">
                                    <div class="record-complex" v-if="record.userExpend > 0">
                                        <span>{{ record.userExpend }}金币</span>
                                        <p class="assist" v-if="record.expendUserNickname">{{ record.expendUserNickname }}</p>
                                    </div>
                                    <span v-else>-</span>
                                </template>
                                <template slot="callIncome" slot-scope="text, record">
                                    <div class="record-complex" v-if="record.userIncome > 0">
                                        <span>{{ record.userIncome }}积分<template v-if="record.profitRate"> - {{ record.profitRate }}</template></span>
                                        <p class="assist" v-if="record.incomeUserNickname">{{ record.incomeUserNickname }}</p>
                                    </div>
                                    <span v-else>-</span>
                                </template>
                                <template slot="action" slot-scope="text, record">
                                    <a @click="onViewRecord(record)">查看</a>
                                </template>
                                <template slot="messageContent" slot-scope="text, record">
                                    <div class="message-content-cell" :class="{ 'is-fail': isMessageSendFail(record) || isMessageModerationFail(record) }">
                                        <span v-if="isMessageSendFail(record) || isMessageModerationFail(record)" class="message-fail-tag">
                                            <a-icon type="exclamation-circle" theme="filled" />
                                        </span>
                                        <template v-if="record.type === 'PHOTO' || record.type === 'IMAGE'">
                                            <x-image
                                                v-if="getExtraValue(record.extra, 'imageUrl')"
                                                :src="getExtraValue(record.extra, 'imageUrl')"
                                                :width="56"
                                                :height="56"
                                                @click.native.stop
                                            />
                                            <span v-else>[图片]</span>
                                        </template>
                                        <span v-else-if="record.type === 'VOICE'">[语音]</span>
                                        <span v-else-if="record.type === 'VIDEO'">[视频]</span>
                                        <span v-else-if="record.type === 'GIFT'">[礼物]</span>
                                        <span v-else-if="record.type === 'VOLTE' || record.type === 'VOLET'">[语音通话]</span>
                                        <span v-else-if="record.type === 'VILTE' || record.type === 'VILET'">[视频通话]</span>
                                        <span v-else>{{ record.content || '' }}</span>
                                    </div>
                                </template>
                                <template slot="messageUser" slot-scope="text, record">
                                    <div class="record-user-cell">
                                        <img v-if="record.toUserAvatarUrl" :src="record.toUserAvatarUrl" class="record-user-avatar" alt="" />
                                        <span v-else class="record-user-avatar-placeholder">头像</span>
                                        <span class="record-user-info">
                                            <span>
                                                {{ record.toUserNickname || '-' }}
                                                <template v-if="record.toUserIsActor === 'Y'">[聊客]</template>
                                            </span>
                                            <span class="record-user-meta">
                                                <template v-if="record.toUserAge">{{ record.toUserAge }}岁</template>
                                                <template v-if="record.toUserProvince || record.toUserCity"> {{ record.toUserProvince }}{{ record.toUserCity }}</template>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                                <template slot="user" slot-scope="text, record">
                                    <div class="record-user-cell">
                                        <img v-if="record.toUserAvatarUrl" :src="record.toUserAvatarUrl" class="record-user-avatar" alt="" />
                                        <span v-else class="record-user-avatar-placeholder">头像</span>
                                        <span class="record-user-info">
                                            <span v-if="record.isVest === 'Y'">【马甲】</span>{{ record.toUserNickname }}
                                            <span class="record-user-meta">{{ record.toUserAge }}岁 {{ record.toUserProvince }}-{{ record.toUserCity }}</span>
                                        </span>
                                    </div>
                                </template>

                                <!-- 充值记录 -->
                                <template slot="rechargeTyp" slot-scope="text, record">
                                    <span v-if="(record.channel || record.payType) === 'ALIPAY'">支付宝</span>
                                    <span v-else>微信</span>
                                </template>
                                <template slot="rechargeOrder" slot-scope="text, record">
                                    <div class="record-complex">
                                        <p>订单号：{{ record.orderId }}</p>
                                        <p class="assist">流水号：{{ record.tradeId }}</p>
                                    </div>
                                </template>
                                <template slot="rechargePay" slot-scope="text, record">
                                    <div class="record-complex">
                                        <p>
                                            <span style="margin-right: 10px;">{{ record.payAmount }}元</span>
                                            <span class="success" v-if="record.payStatus == 'PAID'">已支付</span>
                                            <span class="error" v-else-if="record.payStatus == 'FAILD'">支付失败</span>
                                            <span class="wait" v-else>未支付</span>
                                        </p>
                                        <p class="assist" v-if="record.payTime">{{ record.payTime }}</p>
                                    </div>
                                </template>
                                <template slot="rechargeCallback" slot-scope="text, record">
                                    <div class="record-complex">
                                        <p>
                                            <span class="success" v-if="record.isCallback === 'Y'">已回调</span>
                                            <span class="wait" v-else>未回调</span>
                                        </p>
                                        <p class="assist" v-if="record.callbackTime">{{ record.callbackTime }}</p>
                                    </div>
                                </template>
                                <template slot="rechargeRecharge" slot-scope="text, record">
                                    <div class="record-complex">
                                        <p>
                                            <span style="margin-right: 10px;">{{ record.payAmount }}元</span>
                                            <span class="success" v-if="record.payStatus == 'PAID'">已支付</span>
                                            <span class="error" v-else-if="record.payStatus == 'FAILD'">支付失败</span>
                                            <span class="wait" v-else>未支付</span>
                                        </p>
                                        <p class="assist" v-if="record.rechargeTime">{{ record.rechargeTime }}</p>
                                    </div>
                                </template>
                                <!-- 提现记录 -->
                                <template slot="withdrawApply" slot-scope="text, record">
                                    <div class="record-complex">
                                        <p>{{ record.payAmount }}元</p>
                                        <p class="assist">{{ record.created }}</p>
                                    </div>
                                </template>
                                <template slot="withdrawPay" slot-scope="text, record">
                                    <div class="record-complex">
                                        <p>
                                            <span style="margin-right: 10px;">{{ record.payAmount }}元</span>
                                            <span class="success" v-if="record.payStatus == 'PAID'">已支付</span>
                                            <span class="error" v-else-if="record.payStatus == 'FAILD'">支付失败</span>
                                            <span class="wait" v-else>未支付</span>
                                        </p>
                                    </div>
                                </template>
                                <template slot="withdrawFee" slot-scope="text, record">
                                    <div class="record-complex" v-if="record.fee">{{ record.fee }}元</div>
                                    <span v-else>-</span>
                                </template>
                                <template slot="withdrawFeeRate" slot-scope="text, record">
                                    <div class="record-complex" v-if="record.feeRate">{{ record.feeRate }}%</div>
                                    <span v-else>-</span>
                                </template>
                                <template slot="withdrawStatus" slot-scope="text, record">
                                    <span class="error" v-if="record.payStatus === 'FAILD'">支付失败</span>
                                    <span class="success" v-else-if="record.status === 'PAID'">已支付</span>
                                    <span class="wait" v-else>待处理</span>
                                </template>
                                <!-- 金币/积分流水（与菜单页字段一致） -->
                                <template slot="goldSubject" slot-scope="text, record">
                                    <span>{{ dictLabel(dict.gold, record.subject) || record.subjectText || '-' }}</span>
                                </template>
                                <template slot="scoreSubject" slot-scope="text, record">
                                    <span>{{ dictLabel(dict.score, record.subject) || record.subjectText || '-' }}</span>
                                </template>
                                <template slot="goldChangeAmount" slot-scope="text, record">
                                    <span v-if="record.amount >= 0" class="income-span">{{ record.amount }}</span>
                                    <span v-else class="expend-span">{{ record.amount }}</span>
                                </template>
                                <template slot="scoreChangeAmount" slot-scope="text, record">
                                    <span v-if="record.amount > 0" class="income-span">{{ record.amount }}</span>
                                    <span v-else class="expend-span">{{ record.amount }}</span>
                                </template>
                            </a-table>
                            <div class="x-pagination">
                                <a-pagination
                                    :pageSize="recordPageSize"
                                    v-model="recordPageIndex"
                                    :total="recordTotal"
                                    @change="recordPageChange"
                                    :hideOnSinglePage="true"
                                    show-less-items
                                />
                            </div>
                        </a-card>
					</div>
				</template>
				<template v-else-if="!loading && !userInfo.id">
					<a-empty description="未找到该用户或暂无详情" />
				</template>
			</div>
		</a-spin>
		<conversation-message-drawer ref="conversationDrawer" />
	</div>
</template>

<script>
	import { userDetail, userRechargeList, userCashoutList, userCallList, userMessageList } from '@/api/member/user';
	import { userGoldList, userScoreList } from '@/api/op/user';
	import XImage from "@/components/XImage.vue";
	import ConversationMessageDrawer from '@/components/ConversationMessageDrawer.vue';
	import dict from '@/config/dict';

	export default {
		name: 'UserDetail',
		components: {
			XImage,
			ConversationMessageDrawer,
		},
		props: {
			/** 嵌入抽屉时由父组件传入用户 ID；独立路由页则读 $route.query.id */
			id: {
				type: [Number, String],
				default: null
			},
			/** 嵌入模式：隐藏 page-header，适配抽屉内展示 */
			embedded: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				dict,
				loading: false,
				userInfo: {},
				albumList: [],
				recordTab: 'message',
				recordList: [],
				recordLoading: false,
				recordPageSize: 20,
				recordPageIndex: 1,
				recordTotal: 0,
				voicePlaying: false,
			};
		},
		computed: {
			userId() {
				if (this.id != null && this.id !== '') {
					return this.id;
				}
				return this.$route && this.$route.query ? this.$route.query.id : null;
			},
			headerTitle() {
				if (!this.userInfo.id) {
					return '用户详情';
				}
				return `${this.userInfo.nickname || '用户'} (${this.userInfo.id})`;
			},
			voiceUrl() {
				const raw = this.userInfo.mottoVoice || this.userInfo.voiceMotto || this.userInfo.voice_motto || '';
				if (!raw) {
					return '';
				}
				if (typeof raw === 'object' && raw.url) {
					return raw.url;
				}
				if (typeof raw === 'string') {
					try {
						const parsed = JSON.parse(raw);
						if (parsed && parsed.url) {
							return parsed.url;
						}
					} catch (e) {
						return raw;
					}
					return raw;
				}
				return '';
			},
			statusText() {
				if (this.userInfo.status === 'DEACTIVATE') {
					return '已注销';
				}
				if (this.userInfo.status === 'DISABLE') {
					return '已禁用';
				}
				return '';
			},
			sexText() {
				if (this.userInfo.sex === 'MALE') {
					return '男';
				}
				if (this.userInfo.sex === 'FEMALE') {
					return '女';
				}
				return '-';
			},
			maritalText() {
				return this.dictLabel(this.dict.maritalStates, this.userInfo.maritalStatus);
			},
			locationText() {
				return [this.userInfo.province, this.userInfo.city].filter(Boolean).join('-') || '-';
			},
			mottoText() {
				return this.userInfo.motto || this.userInfo.signature || '';
			},
			rechargeText() {
				const amount = this.userInfo.rechargeAmount != null ? this.userInfo.rechargeAmount : 0;
				const num = this.userInfo.rechargeNum != null ? this.userInfo.rechargeNum : 0;
				return `${amount}元/${num}次`;
			},
			withdrawText() {
				const amount = this.userInfo.cashoutAmount != null ? this.userInfo.cashoutAmount : 0;
				const num = this.userInfo.cashoutNum != null ? this.userInfo.cashoutNum : 0;
				return `${amount}元/${num}次`;
			},
			callText() {
				const num = this.userInfo.totalCallNum != null ? this.userInfo.totalCallNum : 0;
				const minutes = this.userInfo.totalCallLen != null ? this.userInfo.totalCallLen : 0;
				return `${minutes}分钟/${num}次`;
			},
			charmText() {
				const charm = this.userInfo.charm != null ? this.userInfo.charm : '-';
				const weighting = this.userInfo.weighting != null ? this.userInfo.weighting : 0;
				return `${charm} / (${weighting})`;
			},
			heightText() {
				const height = this.userInfo.height;
				if (height == null || height === '') return '-';
				const text = String(height);
				return /cm$/i.test(text) ? text : `${text}cm`;
			},
			registerTimeText() {
				return this.formatDateMinute(this.userInfo.registerTime || this.userInfo.created);
			},
			activeTimeText() {
				return this.formatDateMinute(this.userInfo.activeTime);
			},
			recordTableColumns() {
				if (this.recordTab === 'message') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '内容', key: 'messageContent', scopedSlots: { customRender: 'messageContent' } },
						{ title: '用户', key: 'messageUser', width: 220, scopedSlots: { customRender: 'messageUser' } },
						{ title: '时间', dataIndex: 'createdText', width: 160 }
					];
				}
				if (this.recordTab === 'call') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '类型', key: 'callType', width: 110, scopedSlots: { customRender: 'callType' } },
						{ title: '用户', key: 'callPeer', width: 220, scopedSlots: { customRender: 'callPeer' } },
						{ title: '通话', key: 'callStatus', width: 140, scopedSlots: { customRender: 'callStatus' } },
						{ title: '账单', key: 'callBill', width: 90, scopedSlots: { customRender: 'callBill' } },
						{ title: '支出', key: 'callExpend', width: 100, scopedSlots: { customRender: 'callExpend' } },
						{ title: '收入', key: 'callIncome', width: 100, scopedSlots: { customRender: 'callIncome' } },
						{ title: '创建时间', dataIndex: 'created', width: 160 }
					];
				}
				if (this.recordTab === 'recharge') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '充值渠道', key: 'typ', width: 90, scopedSlots: { customRender: 'rechargeTyp' } },
						{ title: '订单', key: 'order', width: 180, scopedSlots: { customRender: 'rechargeOrder' } },
						{ title: '支付', key: 'pay', width: 140, scopedSlots: { customRender: 'rechargePay' } },
						{ title: '回调', key: 'callback', width: 100, scopedSlots: { customRender: 'rechargeCallback' } },
						{ title: '充值', key: 'recharge', width: 140, scopedSlots: { customRender: 'rechargeRecharge' } },
						{ title: '备注', dataIndex: 'remark', width: 100 },
						{ title: '创建时间', dataIndex: 'created', width: 160 }
					];
				}
				if (this.recordTab === 'withdraw') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '申请金额', key: 'apply', width: 120, scopedSlots: { customRender: 'withdrawApply' } },
						{ title: '支付', key: 'pay', width: 120, scopedSlots: { customRender: 'withdrawPay' } },
						{ title: '手续费', key: 'fee', width: 80, scopedSlots: { customRender: 'withdrawFee' } },
						{ title: '手续费率', key: 'feeRate', width: 80, scopedSlots: { customRender: 'withdrawFeeRate' } },
						{ title: '状态', key: 'status', width: 80, scopedSlots: { customRender: 'withdrawStatus' } },
						{ title: '备注', dataIndex: 'remark', width: 80 },
						{ title: '创建时间', dataIndex: 'created', width: 160 }
					];
				}
				if (this.recordTab === 'gold') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '科目', key: 'goldSubject', width: 120, scopedSlots: { customRender: 'goldSubject' } },
						{ title: '变动金额', key: 'goldChangeAmount', width: 100, scopedSlots: { customRender: 'goldChangeAmount' } },
						{ title: '变动后余额', dataIndex: 'balanceAfter', width: 100 },
						{ title: '创建时间', dataIndex: 'created', width: 160 }
					];
				}
				if (this.recordTab === 'score') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '科目', key: 'scoreSubject', width: 120, scopedSlots: { customRender: 'scoreSubject' } },
						{ title: '变动积分', key: 'scoreChangeAmount', width: 100, scopedSlots: { customRender: 'scoreChangeAmount' } },
						{ title: '变动后积分', dataIndex: 'balanceAfter', width: 100 },
						{ title: '创建时间', dataIndex: 'created', width: 160 }
					];
				}
				if (this.recordTab === 'invite') {
					return [
						{ title: '#', dataIndex: 'id', width: 60 },
						{ title: '用户', key: 'user', width: 180, scopedSlots: { customRender: 'user' } },
						{ title: '邀请时间', dataIndex: 'created', width: 160 },
						{ title: '操作', key: 'action', width: 80, scopedSlots: { customRender: 'action' } }
					];
				}
				return [];
			}
		},
		watch: {
			userId: {
				immediate: true,
				handler(id) {
					if (id) this.fetchDetail();
				}
			}
		},
		methods: {
			fetchDetail() {
				if (!this.userId) return;
				this.stopVoice();
				this.loading = true;
				userDetail(this.userId)
					.then((res) => {
						this.userInfo = res.data.userInfo || {};
						this.albumList = res.data.albumList || [];
						this.$emit('loaded', {
							id: this.userInfo.id,
							nickname: this.userInfo.nickname
						});
						this.fetchRecordList();
					})
					.catch(() => {
						this.userInfo = {};
						this.$message.error('获取用户详情失败');
					})
					.finally(() => {
						this.loading = false;
					});
			},
			dictLabel(arr, value) {
				if (value == null || value === '') return '-';
				const item = (arr || []).find(d => d.value == value);
				return item ? item.label : value;
			},
			formatPhone(u) {
				if (!u) return '-';
				const parts = [u.phoneOs || u.phone_os, u.phoneBrand || u.phone_brand].filter(Boolean);
				return parts.length ? parts.join(' - ') : '-';
			},
			formatDateMinute(value) {
				if (!value) return '-';
				const text = String(value).replace(/-/g, '/');
				const date = new Date(text);
				if (Number.isNaN(date.getTime())) {
					return String(value).replace(/:\d{2}$/, '').slice(0, 16);
				}
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, '0');
				const d = String(date.getDate()).padStart(2, '0');
				const hh = String(date.getHours()).padStart(2, '0');
				const mm = String(date.getMinutes()).padStart(2, '0');
				if (hh === '00' && mm === '00' && String(value).length <= 10) {
					return `${y}-${m}-${d}`;
				}
				return `${y}-${m}-${d} ${hh}:${mm}`;
			},
			goBack() {
				this.stopVoice();
				this.$router.push('/member/userList');
			},
			toggleVoice() {
				if (!this.voiceUrl) {
					this.$message.info('暂无声音秀');
					return;
				}
				const el = this.$refs.voiceAudio;
				if (!el) return;
				try {
					if (this.voicePlaying) {
						el.pause();
					} else {
						el.play();
					}
				} catch (e) {
					this.$message.error('播放失败');
				}
			},
			stopVoice() {
				const el = this.$refs.voiceAudio;
				if (el) {
					el.pause();
					el.currentTime = 0;
				}
				this.voicePlaying = false;
			},
			onRecordTabChange(key) {
				this.recordTab = key;
				this.recordPageIndex = 1;
				this.fetchRecordList();
			},
			fetchRecordList() {
				if (!this.userId) return;
				const tab = this.recordTab;
				const page = this.recordPageIndex;
				const pageSize = this.recordPageSize;

				if (tab === 'invite') {
					const list = (this.userInfo.inviteList || []) || [];
					this.recordList = Array.isArray(list) ? list : [];
					this.recordTotal = this.recordList.length;
					this.recordLoading = false;
					return;
				}

				this.recordLoading = true;
				const setList = (res) => {
					this.recordList = (res.data && res.data.recordList) || [];
					this.recordTotal = (res.data && res.data.totalRow) || 0;
					this.recordLoading = false;
				};
				const onErr = (err) => {
					this.recordList = [];
					this.recordTotal = 0;
					this.recordLoading = false;
					this.$message.error((err && err.response && err.response.data && err.response.data.message) || '加载失败');
				};

				if (tab === 'message') {
					userMessageList({ id: this.userId, page, pageSize }).then(setList).catch(onErr);
					return;
				}
				if (tab === 'call') {
					userCallList({ id: this.userId, page, pageSize }).then(setList).catch(onErr);
					return;
				}
				if (tab === 'recharge') {
					userRechargeList({ id: this.userId, page, pageSize }).then(setList).catch(onErr);
					return;
				}
				if (tab === 'withdraw') {
					userCashoutList({ id: this.userId, page, pageSize }).then(setList).catch(onErr);
					return;
				}
				if (tab === 'gold') {
					userGoldList({ user: this.userId, page, pageSize }).then(setList).catch(onErr);
					return;
				}
				if (tab === 'score') {
					userScoreList({ user: this.userId, page, pageSize }).then(setList).catch(onErr);
					return;
				}
				this.recordLoading = false;
			},
			recordPageChange(current) {
				this.recordPageIndex = current;
				this.fetchRecordList();
			},
			onViewRecord(record) {
				this.openConversation(record);
			},
			openConversation(record) {
				if (!record) return;
				this.$refs.conversationDrawer && this.$refs.conversationDrawer.open({
					conversationId: record.conversationId,
					anchorMessageId: record.id,
					mainUserId: this.userInfo.id,
				});
			},
			recordCustomRow(record) {
				if (this.recordTab !== 'message') return {};
				return {
					style: { cursor: 'pointer' },
					on: {
						click: () => this.openConversation(record),
					},
				};
			},
			parseExtra(extra) {
				if (extra == null || String(extra).trim() === '') return {};
				if (typeof extra === 'object' && !Array.isArray(extra)) return extra;
				try {
					const parsed = JSON.parse(extra);
					return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
				} catch (e) {
					return {};
				}
			},
			getExtraValue(extra, key) {
				const obj = this.parseExtra(extra);
				const val = obj[key];
				return val == null ? '' : val;
			},
			isMessageSendFail(record) {
				if (!record) return false;
				if (record.isSendFail === 'Y' || record.isSendFail === true) return true;
				return record.sendStatus === 'FAILED';
			},
			isMessageModerationFail(record) {
				if (!record) return false;
				if (record.isModerationFail === 'Y' || record.isModerationFail === true) return true;
				const status = record.moderationStatus || '';
				return status === 'REJECTED' || status === 'FAILED';
			},
			recordRowClassName(record) {
				if (this.recordTab === 'message' && (this.isMessageSendFail(record) || this.isMessageModerationFail(record))) {
					return 'message-row-fail';
				}
				return '';
			}
		}
	};
</script>

<style lang="less" scoped>
	.detail-content {
		min-height: 200px;
	}
	.detail-section {
		background-color: #fff;
		padding: 24px;

	}
	.detail-card {
		margin-bottom: 16px;
	}

	.profile-header {
		margin-bottom: 16px;
		.profile-top {
			display: flex;
			align-items: center;
			gap: 16px;
		}
		.avatar-wrap {
			position: relative;
			flex-shrink: 0;
			width: 88px;
			height: 88px;
			overflow: hidden;
			border-radius: 8px;
			background: #f5f5f5;
			.avatar,
			.avatar-placeholder {
				width: 88px;
				height: 88px;
				object-fit: cover;
				display: block;
			}
			.avatar-placeholder {
				display: flex;
				align-items: center;
				justify-content: center;
				color: #999;
				font-size: 12px;
			}
			.avatar-status {
				position: absolute;
				left: 0;
				right: 0;
				bottom: 0;
				height: 22px;
				line-height: 22px;
				text-align: center;
				font-size: 12px;
				color: #fff;
				background: rgba(0, 0, 0, 0.45);
			}
		}
		.profile-meta {
			min-width: 180px;
			flex: 0 1 260px;
		}
		.profile-name-line {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-bottom: 6px;
			.nickname {
				font-weight: 600;
				font-size: 16px;
				color: #333;
			}
			.actor-tag {
				font-size: 13px;
				font-weight: 600;
				color: #fa8c16;
			}
			.voice-link {
				font-size: 13px;
				color: #1890ff;
				cursor: pointer;
				user-select: none;
				&.voice-link--playing {
					color: #096dd9;
				}
				&.voice-link--disabled {
					color: #bbb;
					cursor: not-allowed;
				}
			}
		}
		.profile-basic {
			margin-bottom: 4px;
			color: #666;
			font-size: 13px;
			span + span {
				margin-left: 8px;
			}
		}
		.profile-signature {
			font-size: 12px;
			color: #666;
			line-height: 1.5;
			&.placeholder {
				color: #bbb;
			}
		}
		.profile-divider {
			width: 1px;
			align-self: stretch;
			min-height: 64px;
			background: #e8e8e8;
			margin: 0 8px;
		}
		.profile-stats {
			display: flex;
			align-items: center;
			flex: 0 0 auto;
			gap: 56px;
			.stat-item {
				flex: none;
				text-align: center;
				white-space: nowrap;
			}
			.stat-label {
				margin-bottom: 8px;
				color: #8c8c8c;
				font-size: 13px;
			}
			.stat-value {
				color: #333;
				font-size: 16px;
				line-height: 1.3;
				word-break: break-all;
			}
		}
	}

	.detail-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px 24px;
		.detail-item {
			font-size: 14px;
			line-height: 1.6;
			.label { color: #666; margin-right: 6px; }
			.val { color: #333; }
		}
	}

	.photo-gallery {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin-top: 16px;
		.photo-item {
			width: 88px;
			height: 88px;
			background: #fafafa;
			border-radius: 4px;
			overflow: hidden;
		}
	}

	.user-detail-page--embedded {
		.detail-section {
			padding: 16px 0;
		}
	}

	.record-tabs-card {
		::v-deep .ant-tabs-bar {
			margin-bottom: 16px;
		}
	}
	.record-tabs-card-full {
		width: 100%;
	}
	.record-user-cell {
		display: flex;
		align-items: center;
		gap: 8px;
		.record-user-avatar {
			width: 40px;
			height: 40px;
			object-fit: cover;
			border-radius: 4px;
		}
		.record-user-avatar-placeholder {
			width: 40px;
			height: 40px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			background: #f0f0f0;
			color: #999;
			font-size: 12px;
			border-radius: 4px;
		}
		.record-user-info {
			display: flex;
			flex-direction: column;
			font-size: 13px;
			.record-user-meta {
				color: #999;
				font-size: 12px;
				margin-top: 2px;
			}
		}
	}
	.record-complex {
		p { margin: 0; }
		.assist {
			font-size: 12px;
			color: #999;
		}
	}
	.record-tabs-card {
		::v-deep .ant-table-tbody td {
			vertical-align: middle;
		}
		::v-deep .message-row-fail > td {
			background: #fff1f0;
		}
	}
	.message-content-cell {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		cursor: pointer;
		&.is-fail {
			color: #cf1322;
		}
	}
	.message-fail-tag {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 0 8px;
		height: 22px;
		line-height: 22px;
		border-radius: 11px;
		background: #fff1f0;
		color: #cf1322;
		font-size: 12px;
		font-weight: 600;
		white-space: nowrap;
	}
	.success { color: #52c41a; }
	.wait { color: #faad14; }
	.error { color: #f5222d; }
	.income-span { color: #00b900; }
	.expend-span { color: #ff0000; }

    ::v-deep .ant-page-header {
        padding: 16px 0;
    }
</style>
